import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const CustomerAssetGroupServiceConfig = {
  name: "CustomerAssetGroup",
  annotations: []
} as ServiceConfig;